// import { Tag, Loc, Validation } from 'main.core';
// import { MessageBox } from 'ui.dialogs.messagebox';
// BX.UI.Dialogs.MessageBox.alert("Message");
import './style.css';

BX.namespace('BX.Sale.PersonalOrderComponent');

(function () {
	BX.Sale.PersonalOrderComponent.PersonalOrderList = {
		init: function (parameters) {
			this.result = parameters.result || {};
			this.params = parameters.params || {};
			this.params.paymentList = parameters.paymentList || {};
			this.params.url = parameters.url || "";
			this.params.SLIDER_WIDTH = this.params.SLIDER_WIDTH || window.outerWidth;

			this.template = parameters.template || '';
			this.signedParamsString = parameters.signedParamsString || '';
			this.siteId = parameters.siteId || '';
			this.siteTemplateId = parameters.siteTemplateId || '';
			this.ajaxUrl = this.params.AJAX_PATH || '';
			this.templateFolder = parameters.templateFolder || '';

			if (BX.Main.gridManager != undefined && this.params.GRID_ID) {
				this.grid = BX.Main.gridManager.getInstanceById(this.params.GRID_ID);
			}

			if (BX.SidePanel != undefined) {
				BX.SidePanel.Instance.bindAnchors({
					rules: [{
						condition: [
							// "/personal/orders/?ID=",
							// this.params.PATH_TO_DETAIL.replace(/#ID#/i,'*'),
							"/personal/orders/\?ID=",
							"/personal/orders/(.+)",
						],
						// loader: "tasks:view-loader",
						//Игноривать ссылки, содержащие следующие параметры в Query String
						stopParameters: [
							// "actions="
						],
						//Опции, с которыми откроется слайдер
						options: {
							printable: true,
							contentClassName: "light-sidepanel",
							width: this.params.SLIDER_WIDTH,
							animationDuration: this.SLIDER_DURATION,
							label: {
								class: 'dark',
								text: "Заказ ",
								color: "#000000", //цвет текста
								bgColor: "#ebf1f4", //цвет фона
								opacity: 100 //прозрачность фона
							},
							/* contentCallback: function (slider) {
									let promise = new BX.Promise();
									let order_number = 'order_number';
									debugger;
									slider.getData().set("order_number", order_number); //Записываем новые данные
									return promise;
							}, */
							events: {
								onOpenStart: BX.proxy(this.SidePanelOpenStart, this),
								onBeforeOpenComplete: function (event) { },
								onCloseStart: function (event) { },
								onBeforeCloseComplete: function (event) { },
								onLoad: BX.proxy(this.SidePanelLoad, this),
								onDestroy: function (event) { },
								onEscapePress: function (event) { },
							}
						},
						mobileFriendly: true
					},
						/* {
								condition: [
										/\/online\/\?(IM_DIALOG|IM_HISTORY)=([a-zA-Z0-9_|]+)/i
								],

								//Собственный обработчик нажатия на ссылку.
								//Вместо слайдера откроется мессенджер
								handler: function (event, link) {
										if (!window.BXIM) {
												return;
										}

										var type = link.matches[1];
										var id = link.matches[2];

										if (type === "IM_HISTORY") {
												BXIM.openHistory(id);
										} else {
												BXIM.openMessenger(id);
										}

										event.preventDefault();
								}
						} */
					]
				});
			}
		},
		printOrder: function (id) {
			BX.SidePanel.Instance.open("?ID=" + id + "&access=Y&print=Y", {
				width: this.params.SLIDER_WIDTH,
				animationDuration: this.SLIDER_DURATION,
				events: {
					onCloseByEsc: BX.proxy(this.escHide, this),
					onClose: BX.proxy(this.hide, this),
					onCloseComplete: BX.proxy(this.destroy, this)
				}
			});
		},
		showOrder: function (id) {
			var orderNumber = '';
			if (this.result.ORDERS[id] != undefined) {
				orderNumber = this.result.ORDERS[id].ORDER.ACCOUNT_NUMBER;
			} else {
				if (this.params.GRID_ID == undefined &&
					this.result.GRID.ID != undefined
				) {
					this.params.GRID_ID = this.result.GRID.ID;
				}
				if (this.params.GRID_ID) {
					var grid = BX.Main.gridManager.getInstanceById(this.params.GRID_ID);
					if (grid && grid.getRows().getById(id)) {
						orderNumber = grid.getRows().getById(id).getDataset().orderAccount_number;
					}
				}
			}
			if ((this.params.USE_SIDEPANEL != "Y" && !BX.browser.IsMobile()) || (this.params.USE_SIDEPANEL_MOBILE != "Y" && BX.browser.IsMobile())) {
				location.assign(location.origin + this.params.PATH_TO_DETAIL.replace("#ID#", orderNumber));
			} else {
				return BX.SidePanel.Instance.open("?ID=" + orderNumber, {
					title: "Заказ " + orderNumber,
					printable: true,
					contentClassName: "light-sidepanel",
					width: this.params.SLIDER_WIDTH,
					animationDuration: this.SLIDER_DURATION,
					allowChangeHistory: true,
					allowChangeTitle: true,
					newWindowLabel: true,
					copyLinkLabel: true,
					label: {
						class: 'light',
						contentClassName: "light",
						text: "Заказ ",
						color: "#000000", //цвет текста
						bgColor: "#ebf1f4", //цвет фона
						opacity: 100 //прозрачность фона
					},
					events: {
						onOpenStart: BX.proxy(this.SidePanelOpenStart, this),
						onLoad: BX.proxy(this.SidePanelLoad, this),
						onCloseByEsc: BX.proxy(this.SidePanelEscHide, this),
						onClose: BX.proxy(this.SidePanelHide, this),
						onCloseComplete: BX.proxy(this.SidePanelDestroy, this)
					}
				});
			}
		},
		showHistory: function (id) {
			var basket_number = '';
			if (this.result.ORDERS[id] != undefined) {
				basket_number = this.result.ORDERS[id].ORDER.BASKET_ACCOUNT_NUMBER;
			} else {
				if (this.params.GRID_ID == undefined &&
					this.result.GRID.ID != undefined
				) {
					this.params.GRID_ID = this.result.GRID.ID;
				}
				if (this.params.GRID_ID) {
					var grid = BX.Main.gridManager.getInstanceById(this.params.GRID_ID);
					if (grid && grid.getRows().getById(id)) {
						basket_number = grid.getRows().getById(id).getDataset().order.basket_number;
					}
				}
			}
			return this.showRequest(this.ajaxUrl + "#ID=" + id + "#BASKET_NUMBER=" + basket_number, {
				requestMethod: 'post',
				requestParams: {
					"basket_id": id,
					"account_number": basket_number,
					"action": "HISTORY_BASKET"
				},
				printable: true,
				contentClassName: "light-sidepanel",
				width: '500',
				allowChangeHistory: false,
				cacheable: true,
				label: {
					class: 'dark',
					text: "История корзины ",
					color: "#000000", //цвет текста
					bgColor: "#ebf1f4", //цвет фона
					opacity: 100 //прозрачность фона
				},
				events: {
					onOpenStart: BX.proxy(this.SidePanelOpenStart, this),
					onLoad: BX.proxy(this.SidePanelLoad, this),
				}
			});
		},
		showSellings: function (id) {
			var orderNumber = '';
			var orderTopic = '';
			if (this.result.ORDERS[id] != undefined) {
				orderNumber = this.result.ORDERS[id].ORDER.ACCOUNT_NUMBER;
				orderTopic = this.result.ORDERS[id].ORDER.ORDER_TOPIC;
			} else {
				if (this.params.GRID_ID == undefined &&
					this.result.GRID.ID != undefined
				) {
					this.params.GRID_ID = this.result.GRID.ID;
				}
				if (this.params.GRID_ID) {
					var grid = BX.Main.gridManager.getInstanceById(this.params.GRID_ID);
					if (grid && grid.getRows().getById(id)) {
						orderNumber = grid.getRows().getById(id).getDataset().orderAccount_number;
						orderTopic = grid.getRows().getById(id).getDataset().orderOrder_topic;
					}
				}
			}
			return BX.SidePanel.Instance.open("/personal/docs/?ORDER_ID=" + id + "&ORDER_NUMBER=" + orderNumber + "&ISTOCHNIK=" + orderTopic.toUpperCase() + "&access=Y", {
				title: BX.message('SPOL_DISCREPANCY_DOCUMENT'),
				printable: true,
				contentClassName: "light-sidepanel",
				width: this.params.SLIDER_WIDTH,
				animationDuration: this.SLIDER_DURATION,
				allowChangeHistory: true,
				allowChangeTitle: true,
				label: {
					class: 'light',
					contentClassName: 'light',
					text: BX.message('SPOL_DISCREPANCY_DOCUMENT'),
					color: '#000000',
					bgColor: '#ebf1f4',
					opacity: 100
				},
				events: {
					onOpenStart: BX.proxy(this.SidePanelOpenStart, this),
					onLoad: BX.proxy(this.SidePanelLoad, this),
					onCloseByEsc: BX.proxy(this.SidePanelEscHide, this),
					onClose: BX.proxy(this.SidePanelHide, this),
					onCloseComplete: BX.proxy(this.SidePanelDestroy, this)
				}
			});
		},
		statusOrder: function (id) {
			return this.sendRequest({
				STATUS_ORDER: 'Y',
				ID: id,
				AJAX_URL: this.params.AJAX_URL
			})
		},

		sendRequest: function (data) {
			return BX.ajax({
				method: 'POST',
				dataType: 'html',
				url: data.AJAX_URL || this.params.url,
				data: this.getData(data),
				onsuccess: BX.proxy(function (result) {
					console.log(result);
				}, this),
				onfailure: BX.proxy(function () {
					console.log(result);
				}, this)
			}, this);
		},
		showRequest: function (path, params) {
			let def_params = {
				requestMethod: 'post',
				requestParams: {},
				width: '500',
				allowChangeHistory: false,
				cacheable: true,
				label: {
					color: "#000000", //цвет текста
					bgColor: "#64ba4e", //цвет фона
					opacity: 100 //прозрачность фона
				}
			};
			if (params.requestParams == undefined) params.requestParams = {};
			params.requestParams = Object.assign(params.requestParams, this.getData(), def_params.requestParams);
			params = Object.assign(def_params, params);
			return BX.SidePanel.Instance.open(path, params);
		},
		SidePanelOpenStart: function (event) {
			let slider = event.getSlider(),
				order_id,
				order_number;
			if (slider.options.requestParams != undefined && slider.options.requestParams.basket_id) {
				basket_id = slider.options.requestParams.basket_id;
			} else if (slider.url.search(/.+ID=([a-z_0-9]+).*/i) >= 0) {
				order_id = slider.url.replace(/.+ID=([a-z_0-9]+).*/i, '$1');
			}
			if (slider.options.requestParams != undefined && slider.options.requestParams.account_number) {
				order_number = slider.options.requestParams.account_number;
			} else if (slider.url.search(/.+ORDER_NUMBER=([a-z_0-9]+).*/i) >= 0) {
				order_number = slider.url.replace(/.+ORDER_NUMBER=([a-z_0-9]+).*/i, '$1');
			}
			if (slider.options.label.text && (order_number || order_id)) {
				slider.getLabel().setText(slider.options.label.text + ' ' + (order_number || order_id));
			}
			if (slider.options.label.class && slider.getLabel().layout != undefined) {
				slider.getLabel().layout.closeBtn.classList.add(slider.options.label.class)
			}
		},
		SidePanelLoad: function (event) {
			// TODO найти способ прочие ссылки открывать в родительском окне
			BX.ready(function () {
				let a = BX.findChildren(document, {
					tag: "a"
				}, true);
				a.forEach(tag_a => {
					BX.adjust(tag_a, {
						attrs: {
							target: "_top"
						}
					});
				});
			});
			var slider = event.getSlider();
			if (slider) slider.getWindow().$body.find('form[target]').attr('target', slider.getFrameId());
		},
		SidePanelEscHide: function () {

		},
		SidePanelHide: function () {

		},
		SidePanelDestroy: function () {

		},
		getData: function (data) {
			data = data || {};

			if (this.params.ACTION_VARIABLE) {
				data[this.params.ACTION_VARIABLE] = this.lastAction;
			}
			data.via_ajax = 'Y';
			data.sessid = BX.bitrix_sessid();
			// data.site_id = this.siteId;
			// data.template = this.template;
			// data.site_template_id = this.siteTemplateId;
			data.signedParamsString = this.signedParamsString;

			return data;
		},
	};
})();
